import type React from 'react';

import { useParams } from 'js/lib/useRouter';

import { useDegreePlanPropertiesContext } from 'bundles/degree-home/components/v3-dpm/context/DegreePlanPropertiesContext';

type InputProps = {
  v2: React.ReactElement;
  v3: React.ReactElement | null;
};

const DegreeHomeV2BranchWrapper = ({ v2, v3 }: InputProps) => {
  const { degreeSlug } = useParams();
  const { isDPMEnabled, loading } = useDegreePlanPropertiesContext();

  if (loading) {
    return null;
  } else if (degreeSlug && isDPMEnabled) {
    return v3;
  } else {
    return v2;
  }
};

export default DegreeHomeV2BranchWrapper;
